// Lightweight, opt-in analytics. Loads GA4 / Google Ads / Meta Pixel only if
// the matching IDs exist in the environment. Safe to call when no IDs are set.
const GA4 = process.env.REACT_APP_GA4_ID;
const GADS = process.env.REACT_APP_GADS_ID;
// Separate conversion labels: one for form leads, one for phone calls.
// Falls back to the generic label if the specific one is not set.
const GADS_LEAD_LABEL = process.env.REACT_APP_GADS_LEAD_LABEL || process.env.REACT_APP_GADS_LABEL;
const GADS_CALL_LABEL = process.env.REACT_APP_GADS_CALL_LABEL || process.env.REACT_APP_GADS_LABEL;
const META = process.env.REACT_APP_META_PIXEL_ID;

let inited = false;

export function initAnalytics() {
  if (inited || typeof window === "undefined") return;
  inited = true;

  if (GA4 || GADS) {
    const primary = GA4 || GADS;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${primary}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    if (GA4) window.gtag("config", GA4);
    if (GADS) window.gtag("config", GADS);
  }

  if (META) {
    /* eslint-disable */
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", META);
    window.fbq("track", "PageView");
  }
}

// Fire a lead conversion (form submitted). value optional (SEK).
export function trackLead(value = 0) {
  if (typeof window === "undefined") return;
  if (window.gtag) {
    window.gtag("event", "generate_lead", { currency: "SEK", value });
    if (GADS && GADS_LEAD_LABEL) window.gtag("event", "conversion", { send_to: `${GADS}/${GADS_LEAD_LABEL}`, value, currency: "SEK" });
  }
  if (window.fbq) window.fbq("track", "Lead", { currency: "SEK", value });
}

// Fire a phone-call conversion (click-to-call).
export function trackCall() {
  if (typeof window === "undefined") return;
  if (window.gtag) {
    window.gtag("event", "phone_call");
    if (GADS && GADS_CALL_LABEL) window.gtag("event", "conversion", { send_to: `${GADS}/${GADS_CALL_LABEL}` });
  }
  if (window.fbq) window.fbq("track", "Contact");
}
